<template>

 <div class="ml-10" style="height:80%">
  <vue-scroll :ops="scrollBar">
    <div  class="m-0">
          <b-modal ref="newVehicleModal" size="lg" title="Add New Vehicle">
            <vehiclesDetails
              :driverId="driverId"
              :driverCar="currentDefaultCar"
              :selectedVehicle="selectedVehicle"
              :createEvent="actionCreateVehicle"
              :createdVehicle="createdVehicle"
            />
            <template v-slot:modal-footer="{cancel}">
              <!-- Emulate built in modal footer ok and cancel button actions -->
              <b-button size="sm" variant="danger" @click="cancel()">Close</b-button>
              <!-- Button with custom close trigger value -->
              <b-button size="sm" variant="primary" @click="createVehicle">Create Vehicle</b-button>
            </template>
          </b-modal>

          <b-table
          :items="vehicles"
          :fields="vehicle_fields"
          stacked="sm"
        >
          <template #head()="data">
              <b-row >
              <b-col cols="6" >
                  <span
              ><strong>{{ data.label }}</strong></span>
              </b-col>
              <b-col cols="6" align="right">
                  <b-button pill variant="primary" size="sm" @click="addVehicle"  
                            v-b-tooltip.hover title="Add new vehicle">
                      <font-awesome-icon icon="plus" />
                  </b-button>
              </b-col>
              </b-row>
          </template>
          <template v-slot:cell(vehicles)="data">
            <b-row style="font-size:12px;">
              <b-col cols="4" class="pl-15" >
                <img :src="data.item.photoUrl"
                       :style="{'width': '120px'}"
                        v-if="typeof data.item.photoUrl !== 'undefined'"/>
                  <div v-else>
                      <font-awesome-icon icon="image" :style="{'font-size': '80px'}" />
                  </div>
              </b-col>
              <b-col cols="8" class="p-0">
                <b-row class="m-0">
                  <b-col cols="3">
                    <b-form-group  label="Make">
                      {{data.item.make}}
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                     <b-form-group  label="Model">
                      {{data.item.model}}
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                  <b-form-group  label="Colour">
                      {{data.item.colour}}
                    </b-form-group>
                  </b-col>
                  <b-col cols="2">
                <b-button variant="none" @click="openVehicles(data)"
                          v-b-tooltip.hover title="Edit">
                    <font-awesome-icon icon="edit" class="text-primary" />
                </b-button>
              </b-col>
                  <b-col cols="8" class="m-0;p-0">
                    <b-form-group class="m-0" >
                      <label> Number Plate : <span style="font-weight: normal">{{data.item.plateNumber}}</span></label>
                    </b-form-group>
                    <b-form-group class="m-0" >
                       <label>VIN number : <span style="font-weight: normal">{{data.item.vinNumber}}</span></label>
                    </b-form-group>
                  </b-col>
                  <b-col cols="4" align="center">
                 <b-button  variant="secondary" size="xs"
                            v-if="data.item._id === currentDefaultCar"
                  >Default</b-button>
                  <div v-else>
                    <b-button  variant="success" size="xs" class="pt-5"
                     v-if="data.item.status==='active'"
                     @click="setDefaultVehicle(data.item._id, data.item.carSeats,data.item.status)"
                >Set Default</b-button>
                    <b-button  variant="danger" size="xs" class="pt-5"
                     v-else-if="data.item.status==='inactive'" v-b-tooltip.hover :title="data.item.comment!==undefined?data.item.comment:''"
                >Inactive</b-button>
                    <b-button  variant="outline-warning" size="xs" class="pt-5"
                     v-else
                >Awaiting<br/>approval</b-button>
                  </div>
              </b-col>
                </b-row>
              </b-col>
            </b-row>
          </template>
          </b-table>

          <div class="text-center" v-if="vehicles.length == 0">
            <p>No vehicles attached to your profile.</p>
          </div>
        </div>

    <b-modal class="editModal" ref="editVehicleModal" size="lg" v-model="show" hide-footer>
      <template #modal-title>
        <strong>Edit Vehicle</strong>
      </template>
          <b-tabs content-class="mt-3" variant="secondary">
              <b-tab title="Details" active lazy>
                <vehiclesDetails 
                  :driverId="driverId" 
                  :driverCar="currentDefaultCar" 
                  :selectedVehicle="selectedVehicle" 
                  @vehicleChange="updateVehicles"
                  @closeCallback="closeEditModal"
                  />
              </b-tab>
              <b-tab title="Photo" lazy>
                <vehiclesPhotos
                  :selectedVehicle.sync="selectedVehicle"
                  :uploadedImageCallback="uploadedImageCallback"
                  :driverId="driverId"
                  @closeCallback="closeEditModal"
                />
              </b-tab>
              <b-tab title="Facilities" lazy>
                <vehicleFacilities 
                  :driverId="driverId" 
                  :selectedVehicle="selectedVehicle"
                  @closeCallback="closeEditModal"></vehicleFacilities>
              </b-tab>
              <b-tab title="Documents" lazy>
                <vehiclesDocs 
                  :driverId="driverId" 
                  :selectedVehicle="selectedVehicle" 
                  @updatedCount="docCountChanged"
                  @closeCallback="closeEditModal"/>
              </b-tab>
        </b-tabs>
    </b-modal>
 </vue-scroll>
  </div>
  
</template>

<script>
import shebahApi from "@/services/shebah/index";
import vehiclesDetails from "./vehicle-details.vue";
import vehiclesDocs from "./vehicleDoc";
import vehiclesPhotos from "./vehicle-photos";
import vehicleFacilities from "./vehicle-facilities";

export default {
  name: "vehicles",
  components: {
    vehiclesDetails,
    vehiclesDocs,
    vehiclesPhotos,
    vehicleFacilities
  },
  props:{
    driverId:String,
    defaultCar:String
  },
  computed: {
     scrollBar() {
      return this.$store.getters["general/scrollbar"];
    }
  },
  watch: {},
  data() {
    return {
      show: false,
      currentDefaultCar:this.defaultCar,
      actionCreateVehicle: false,
      selectedVehicle: {},
      selectedVehicleErrors: {},
      vehicle: {
        pictureUploadId: null,
        make: "",
        makeId: "",
        model: "",
        modelId: "",
        colour: "",
        carSeats: 4,
        plateNumber: "",
        year: "",
        vinNumber:"",
        facilities: []
      },
      vehicle_fields: [
        {
          key: "vehicles"
        }
      ],
      vehicles: [],
      tabs: []
    };
  },
  async created() {
    this.currentDefaultCar=this.defaultCar;
    this.resetVehicle();
    this.getVehicles();
   
  },
  methods: {
    async getVehicles() {
      this.vehicles = await shebahApi.api.drivers.vehicles.getVehicles(this.driverId);
    },
    async openVehicles(vehicle) {
      this.$refs.editVehicleModal.show();
      this.selectedVehicle = await shebahApi.api.drivers.vehicles.getVehicle(
          this.driverId,
          vehicle.item._id
        );
    },
    resetVehicle() {
      this.selectedVehicle = Object.assign({}, this.vehicle);
    },
    addVehicle() {
      this.$refs.newVehicleModal.show();
      this.resetVehicle();
    },
    async createVehicle() {
      this.actionCreateVehicle = true;
      setTimeout(() => {
        this.actionCreateVehicle = false;
      }, 100);
    },
    async createdVehicle(vehicle) {
       this.$refs.newVehicleModal.hide();
      this.$refs.editVehicleModal.show();
       this.selectedVehicle = await shebahApi.api.drivers.vehicles.getVehicle(
          this.driverId,
          vehicle._id
        );
        this.getVehicles();
    },
    async setDefaultVehicle(vehicleId, carSeats,status) {
      if(status==='active'){
      await shebahApi.api.drivers.updateDefaultVehicle( this.driverId,{
        car: vehicleId,
        carSeats: carSeats
      });
      this.currentDefaultCar=vehicleId;
      }
    },
    async uploadedImageCallback() {
      this.selectedVehicle = await shebahApi.api.drivers.vehicles.getVehicle(
        this.driverId,
        this.selectedVehicle._id
      );
      this.getVehicles();
    },
    docCountChanged(ob){
        this.$emit("updated", ob);
      },
    updateVehicles(details){
      const vehicleClone = [].concat(this.vehicles);
      for (let vehicle of vehicleClone) {
        if (vehicle._id === details._id) {
          vehicle.pictureUploadId= details.pictureUploadId,
          vehicle.make=details.make,
          vehicle.makeId=details.makeId,
          vehicle.model=details.model,
          vehicle.modelId=details.modelId,
          vehicle.colour=details.colour,
          vehicle.carSeats=details.carSeats,
          vehicle.plateNumber=details.plateNumber,
          vehicle.status=details.status,
          vehicle.year=details.year,
          vehicle.vinNumber=details.vinNumber,
          vehicle.facilities=details.facilities
        }
      }

      this.vehicles = vehicleClone;
    },
    closeEditModal(){
       this.$refs.editVehicleModal.hide();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.active-facilities {
  display: inline-block;
  margin-right: 10px;
  font-weight: 100 !important;
}
.modal-header{
  padding-bottom: 0 !important;
}
</style>
